// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.vxe-toolbar[data-v-17a8f1ce] {\r\n  padding-left: 0\n}\n[data-v-17a8f1ce] .vxe-table {\r\n  height: 192px;\r\n  overflow: hidden;\n}\r\n", ""]);
// Exports
module.exports = exports;
